import React, { useCallback } from 'react';
import styled from 'styled-components';

import type { IconName } from '@seuk/design-system/atoms';
import { BaseLink, Icon, Typography } from '@seuk/design-system/atoms';

export interface CategoryLinkData {
  name: string;
  label: string;
  href: string;
}

export interface CategoryLinkProps {
  label: string;
  name: string;
  icon?: IconName;

  subcategories: string[];
  onClick: (linkData: CategoryLinkData) => void;
}

const StyledLink = styled(BaseLink)`
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.text.onSurface.strong};
  background: ${({ theme }) => theme.palette.background.base};
  padding: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(6)};
`;

const LinkText = styled.div`
  flex-grow: 1;
  box-sizing: border-box;
  margin: 0 ${({ theme }) => theme.spacing(4)};
`;

const ChevronContainer = styled.div`
  transform: rotateZ(-90deg);
`;

const Subcategories = styled.div`
  ${({ theme }) => theme.typography.paragraph.small.normal}

  display: none;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: block;
  }
`;

export const CategoryLink = ({ name, label, onClick, subcategories, icon }: CategoryLinkProps) => {
  const onClickLocal = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      const target = e.currentTarget;

      onClick({
        name: name,
        href: target.href,
        label: label,
      });
    },
    [onClick, name, label]
  );

  return (
    <StyledLink href={name} onClick={onClickLocal}>
      {icon && <Icon name={icon} width={62} height={62} color="#0097A9" style={{ minWidth: 62 }} />}
      <LinkText>
        <Typography variant="h4">{label}</Typography>
        <Subcategories>{subcategories.join(', ')}</Subcategories>
      </LinkText>
      <ChevronContainer>
        <Icon name="Chevron" />
      </ChevronContainer>
    </StyledLink>
  );
};
